@import "./helper/scss-helper";
:host {
  display: block;
  @include eon-typography();
  @include slotted-margins("*:not([slot])");

  * {
    box-sizing: border-box;
    outline: 0 none;
    text-rendering: optimizelegibility;
  }
}

.#{$prefix}offset-teaser-wrapper {
  position: relative;

  .#{$prefix}image-layer {
    position: relative;

    .#{$prefix}image-wrapper {
      position: relative;

      &::after {
        @include aspect-ratio(2, 1);

        @include for-size(phone) {
          @include aspect-ratio(4, 3);
        }
      }
    }

    .#{$prefix}color-bar {
      position: absolute;
      left: 32px;
      top: 0;
      width: 16px;
      height: 100%;
      z-index: 1;

      @include for-size(desktop) {
        left: 24px;
      }

      @include for-size(tablet) {
        left: 24px;
      }

      @include for-size(phone) {
        left: 16px;
        width: 12px;
      }

      &.#{$prefix}color-bar-active {
        background-color: v(currentColorBar);
      }
    }
  }

  .#{$prefix}content-layer {
    @include borderRadius("variant_four", "content");
    // content-layer must be overflow:hidden in all other Variant (set by mixin "borderradius", except in Variant4, so
    // at this place it is overridden by "unset"
    overflow: unset;
    position: relative;
    width: calc(100% * 8 / 12);
    height: auto;
    margin-top: -48px;
    background-color: v(visibleBackgroundColor);
    word-wrap: break-word; // For EDGE 18
    word-break: break-word; // For Chrome, Safari, Firefox
    z-index: 1;

    @include boxShadow("variant_four", "content");

    .#{$prefix}content-wrapper {
      position: relative;
      width: 100%;
      padding: 48px 48px 48px 48px;
      display: flex;
      flex-direction: column;

      &.#{$prefix}alignment-left {
        align-items: flex-start;
        .#{$prefix}offset-teaser-content {
          text-align: left;
        }
      }
      &.#{$prefix}alignment-center {
        align-items: center;
        .#{$prefix}offset-teaser-content {
          text-align: center;
        }
      }
      &.#{$prefix}alignment-right {
        align-items: flex-end;
        .#{$prefix}offset-teaser-content {
          text-align: right;
        }
      }

      @include for-size(desktop) {
        padding: 40px 32px 48px 32px;
      }

      @include for-size(tablet) {
        padding: 40px 32px 48px 32px;
      }

      @include for-size(phone) {
        padding: 32px 24px 48px 24px;
      }
    }

    @include for-size(desktop) {
      margin-top: -40px;
    }

    @include for-size(tablet) {
      margin-top: -40px;
    }

    @include for-size(phone) {
      width: 100%;
      margin-top: 0;
    }

    .#{$prefix}offset-teaser-headline {
      position: absolute;
      color: v(headlineColor);
      display: block;
      white-space: inherit;

      &.#{$prefix}headline-alignment-left {
        left: 32px;
        bottom: calc(100% + 48px);

        @include for-size(desktop) {
          left: 32px;
          bottom: calc(100% + 40px);
        }

        @include for-size(tablet) {
          left: 32px;
          bottom: calc(100% + 40px);
        }
      }

      &.#{$prefix}headline-alignment-right {
        right: calc((100% / 8) * -4 + 48px);
        bottom: calc(100% + 48px);

        @include for-size(desktop) {
          right: calc((100% / 8) * -4 + 40px);
          bottom: calc(100% + 40px);
        }

        @include for-size(tablet) {
          right: calc((100% / 8) * -4 + 40px);
          bottom: calc(100% + 40px);
        }
      }

      @include for-size(tablet-or-larger) {
        color: $eon-bright;
      }

      @include for-size(phone) {
        position: relative !important;
        right: unset !important;
        left: unset !important;
        bottom: unset !important;
        margin-bottom: 24px;
      }
    }

    .#{$prefix}offset-teaser-subheadline {
      position: relative;
      margin-bottom: 24px;
      color: v(contentColor);
      display: block;

      @include for-size(tablet) {
        margin-bottom: 16px;
      }

      @include for-size(phone) {
        margin-bottom: 16px;
      }
    }

    .#{$prefix}offset-teaser-content {
      position: relative;
      margin-bottom: 32px;
      font-size: 18px;
      display: block;

      @include for-size(phone) {
        margin-bottom: 24px;
      }
    }
  }

  &.#{$prefix}has-color-bar {
    .#{$prefix}variant_four {
      .#{$prefix}headline-alignment-left {
        left: 60px;
      }
    }
  }
}

::slotted(*) {
  color: v(contentColor) !important;
  font-size: 18px !important;
}

::slotted(eon-ui-link) {
  --contentColor: var(--linkColor) !important;
  --contentHoverColor: var(--linkHoverColor) !important;
}

::slotted(eon-ui-linkList) {
  --linklistColor: var(--linkColor) !important;
  --linklistHoverColor: var(--linkHoverColor) !important;
}
::slotted(eon-ui-image) {
  @include borderRadius("variant_four", "image");
  @include boxShadow("variant_four", "image");
}
